import React from "react";
import { CustomChip } from "../../../../shared/components/chips/CustomChip";
import colors from "../../../../shared/themes/colors";

export interface AffectedPartCategoryChipProps {
  value?: string;
}

const AffectedPartCategoryChip = ({ value }: AffectedPartCategoryChipProps) => {
  return (
    <CustomChip
      value={value}
      sx={{ color: colors.secondary.gray20, background: colors.primary.lightBlue3 }}
    />
  );
};

export default AffectedPartCategoryChip;
